import React from 'react';
import intl from 'react-intl-universal';
import { useOutletContext } from 'react-router-dom';
import SettingsLayout from 'components/SettingsTabLayout';
import Profile from './components/ProfileTab';
import SecurityTab from './components/SecurityTab';
import MFATab from './components/MFATab';
import NotificationTab from './components/NotificationTab';
import { Card } from '@mui/material';

const PersonalSettings = () => {
  const { userInfo } = useOutletContext();

  const tabs = [
    {
      label: intl.get('personal_settings_tab_label_preference'),
      index: 0,
      component: <Profile userInfo={userInfo} />,
    },
    {
      label: intl.get('personal_settings_tab_label_password'),
      index: 1,
      component: <SecurityTab />,
    },
    {
      label: intl.get('personal_settings_tab_label_mfa'),
      index: 2,
      component: <MFATab />,
    },
    {
      label: intl.get('personal_settings_notification_tab_name'),
      index: 3,
      component: <NotificationTab userInfo={userInfo} />,
    },
  ];

  return (
    <Card sx={{ margin: 2, marginTop: 3, overflow: 'visible' }}>
      <SettingsLayout
        title={intl.get('personal_settings_text_title_personal_settings')}
        tabs={tabs}
        settingsType="personal"
      />
    </Card>
  );
};

export default PersonalSettings;
